import React from "react";
import { Offcanvas } from "react-bootstrap";
import Moment from "react-moment";

const ViewSubjectMilestone = ({
  Show,
  Hide,
  Title,
  subjectTimeLine,
  subjectRegisteredDate,
}) => {
  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="m-2 d-flex justify-content-center gap-3  timeline__section">
          <div>
            <div className="overview_left_section mt-2">
              <p className="m-0 text-end">
                <div>Data</div> <div>Entry</div>
              </p>
            </div>
            <div className="timeline" style={{ textTransform: "uppercase" }}>
              <div className="tl-contents">
                <div className="tl-header">
                  <span className="tl-markers"></span>
                  <p className="tl-titles">
                    <Moment format="YYYY-MM-DD" withTitle>
                      {subjectRegisteredDate}
                    </Moment>
                  </p>
                </div>
              </div>
              {subjectTimeLine?.map((item, index) => (
                <div key={index} className="tl-contents">
                  <div className="tl-header">
                    <span
                      className={
                        item.visitStatus ? "tl-markers" : "tl-markers-gray"
                      }
                    ></span>
                    <p className="tl-titles">
                      <b>Planned Date : </b>
                      {item.plannedDate || "DD-MMM-YYYY"}
                    </p>
                    {item.actualDate ? (
                      <p className="tl-titles">
                        <b>Actual Date : </b>
                        {item.actualDate}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <div className="overview_left_section mt-2">
              <p className="m-0">
                <div>SDV</div> <div>Status</div>{" "}
              </p>
            </div>
            <div className="timeline">
              <div className="tl-content">
                <div className="tl-header">
                  <span className="tl-marker"></span>
                  <p className="tl-title">Registered In EDC</p>
                </div>
              </div>
              {subjectTimeLine?.map((item, index) => (
                <div key={index} className="tl-content">
                  <div className="tl-header">
                    <span
                      className={
                        item.status === "query"
                          ? "tl-marker-red"
                          : item.status === "completed"
                          ? "tl-marker"
                          : "tl-marker-gray"
                      }
                    ></span>
                    <p className="tl-title">{item.milestoneName}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Offcanvas.Body>
      <div className="p-2 bg-light border-top shadow-sm text-end">
        <button className="updateProfile">Download Timeline</button>
      </div>
    </Offcanvas>
  );
};

export default ViewSubjectMilestone;
